/*
  德语
*/
export default {
  home: {}
}
